import React, { useState } from 'react';
import './SettingsPage.css';
import { Save, User, Bell, PieChart, Moon, Sun, Monitor } from 'lucide-react';

const SettingsPage: React.FC = () => {
  const [theme, setTheme] = useState('system');
  const [notificationsEnabled, setNotificationsEnabled] = useState(true);
  const [analyticsEnabled, setAnalyticsEnabled] = useState(true);
  const [privacyMode, setPrivacyMode] = useState(false);
  const [saveStatus, setSaveStatus] = useState<null | 'saving' | 'saved'>(null);

  const handleSaveSettings = () => {
    setSaveStatus('saving');

    // Simulate API call delay
    setTimeout(() => {
      setSaveStatus('saved');

      // Reset status after 2 seconds
      setTimeout(() => {
        setSaveStatus(null);
      }, 2000);
    }, 1000);
  };

  return (
    <div className="settings-page">
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `
            window._uxa = window._uxa || [];
            window._uxa.push(["trackDynamicVariable", { key: "settings", value: "settings_value" }]);
          `
        }}
      />
      <div className="settings-header">
        <h1>Settings</h1>
        <p>Manage your application preferences and account settings</p>
      </div>

      <div className="settings-grid">
        <div className="settings-card">
          <div className="settings-card-header">
            <User size={20} />
            <h2>Account Settings</h2>
          </div>
          <div className="settings-card-content">
            <div className="settings-field">
              <label>Username</label>
              <input type="text" value="admin@contentsquare.com" disabled />
            </div>
            <div className="settings-field">
              <label>Role</label>
              <input type="text" value="Administrator" disabled />
            </div>
            <div className="settings-field">
              <label>Last login</label>
              <input type="text" value="September 14, 2025 - 09:34 AM" disabled />
            </div>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-card-header">
            <Bell size={20} />
            <h2>Notification Settings</h2>
          </div>
          <div className="settings-card-content">
            <div className="settings-toggle">
              <label>Enable notifications</label>
              <div
                className={`toggle ${notificationsEnabled ? 'active' : ''}`}
                onClick={() => setNotificationsEnabled(!notificationsEnabled)}
              >
                <div className="toggle-handle"></div>
              </div>
            </div>
            <div className="settings-field">
              <label>Email notifications</label>
              <select>
                <option>Immediate</option>
                <option>Daily digest</option>
                <option>Weekly digest</option>
                <option>Disabled</option>
              </select>
            </div>
            <div className="settings-field">
              <label>Alert threshold</label>
              <select>
                <option>All alerts</option>
                <option>Critical only</option>
                <option>Critical and warnings</option>
              </select>
            </div>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-card-header">
            <Monitor size={20} />
            <h2>Display Settings</h2>
          </div>
          <div className="settings-card-content">
            <div className="settings-field">
              <label>Theme</label>
              <div className="theme-options">
                <button
                  className={`theme-button ${theme === 'light' ? 'active' : ''}`}
                  onClick={() => setTheme('light')}
                >
                  <Sun size={16} />
                  <span>Light</span>
                </button>
                <button
                  className={`theme-button ${theme === 'dark' ? 'active' : ''}`}
                  onClick={() => setTheme('dark')}
                >
                  <Moon size={16} />
                  <span>Dark</span>
                </button>
                <button
                  className={`theme-button ${theme === 'system' ? 'active' : ''}`}
                  onClick={() => setTheme('system')}
                >
                  <Monitor size={16} />
                  <span>System</span>
                </button>
              </div>
            </div>
            <div className="settings-toggle">
              <label>Privacy mode</label>
              <div
                className={`toggle ${privacyMode ? 'active' : ''}`}
                onClick={() => setPrivacyMode(!privacyMode)}
              >
                <div className="toggle-handle"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-card-header">
            <PieChart size={20} />
            <h2>Analytics Settings</h2>
          </div>
          <div className="settings-card-content">
            <div className="settings-toggle">
              <label>Enable analytics</label>
              <div
                className={`toggle ${analyticsEnabled ? 'active' : ''}`}
                onClick={() => setAnalyticsEnabled(!analyticsEnabled)}
              >
                <div className="toggle-handle"></div>
              </div>
            </div>
            <div className="settings-field">
              <label>Default dashboard view</label>
              <select>
                <option>Overview</option>
                <option>Metrics</option>
                <option>Alerts</option>
                <option>Database</option>
              </select>
            </div>
            <div className="settings-field">
              <label>Default time range</label>
              <select>
                <option>Last 1h</option>
                <option>Last 3h</option>
                <option>Last 6h</option>
                <option>Last 24h</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="settings-actions">
        <button className="save-button" onClick={handleSaveSettings}>
          <Save size={16} />
          {saveStatus === 'saving' ? 'Saving...' : saveStatus === 'saved' ? 'Saved!' : 'Save Settings'}
        </button>
      </div>
    </div>
  );
};

export default SettingsPage;
